export function extractQuestions(data) {
    const questionAnswerDict = {};

    for (const key in data) {
        if (key.startsWith("questions_")) {
            const questionsObject = data[key];

            for (const questionKey in questionsObject) {
                questionAnswerDict[questionKey] = questionsObject[questionKey];
            }
        }
    }
    return Object.keys(questionAnswerDict).length ? questionAnswerDict : null;
}